import { GroupSecurity } from '@quromedical/fhir-common';
import { MediaGetResponse } from '@quromedical/models';
import { CrudForm, SubmissionHandler } from 'components/form';
import { Field } from 'components/types';
import { WithGroup } from 'core/auth';
import { Button } from 'design-system';
import { Dialog } from 'design-system/components';
import { useBoolean } from 'hooks/useBoolean';
import { useRevalidation } from 'hooks/useRevalidation';
import { MediaApi } from 'integration';
import React, { useCallback } from 'react';
import { strings } from 'strings';
import { z } from 'zod';

const api = new MediaApi();

export interface FormData {
  title: string;
  patientId: string;
  media: MediaGetResponse;
}
type FormDataTitle = Omit<FormData, 'media' | 'patientId'>;

const formSchema = z.object({
  title: z.string(),
});

export const MediaUpdate: React.FC<FormData> = ({ title, patientId, media }) => {
  const expanded = useBoolean(false);
  const revalidate = useRevalidation(patientId);
  const handleSubmit = useCallback<SubmissionHandler<FormDataTitle>>(
    async (data: FormDataTitle) => {
      try {
        await api.updateMedia({ ...media, title: data.title });
        await revalidate();
        expanded.setFalse();
        return {};
      } catch (error) {
        return { error };
      }
    },
    [expanded, media, revalidate]
  );

  const onPress = expanded.setTrue;

  const fields: Field<FormDataTitle>[] = [
    {
      subfields: [
        {
          key: 'title',
          type: 'text-box',
          label: strings.LabelTitle,
        },
      ],
    },
  ];

  return (
    <WithGroup groups={[GroupSecurity.MediaUpdate]}>
      <Button iconPosition="right" onPress={onPress} icon={'edit'} text={strings.LabelEditTitle} />

      <Dialog isOpen={expanded.value} title={strings.LabelEditTitle}>
        <CrudForm
          hasCard={false}
          initialValues={{ title }}
          validationSchema={formSchema}
          onSubmit={handleSubmit}
          onSecondarySubmit={expanded.setFalse}
          showSecondarySubmitButton
          secondaryButtonText={strings.ButtonTextClose}
          fields={fields}
        />
      </Dialog>
    </WithGroup>
  );
};
